/**
 * Виробничий календар організації (ч.1118).
 *
 * Календар індивідуальний: шаблон платформи за режимом організації (воєнний
 * стан / мирний час) + власні дні організації. Шаблон клієнт не змінює.
 */
import { api } from './client';

export type DayType = 'WORKDAY' | 'WEEKEND' | 'HOLIDAY' | 'NON_WORKING_DAY';
export type DaySource = 'OWN' | 'TEMPLATE' | 'DEFAULT';

/** «Особливий» день: неробочий за календарем або власний день організації. */
export interface CalendarDay {
  day_date: string;
  day_type: DayType;
  holiday_name: string | null;
  /** Коментар власного дня (підстава: наказ, колективний договір). */
  comment?: string | null;
  source: DaySource;
  /** Яким день був би без власного дня організації. */
  template_type: DayType;
}

export interface CalendarMonthNorm {
  month: number;
  calendar_days: number;
  workdays: number;
  hours: number;
}

export interface OrgCalendarYear {
  organization_id: string;
  year: number;
  is_wartime: boolean;
  days: CalendarDay[];
  months: CalendarMonthNorm[];
  own_days_count: number;
}

export interface OrgCalendarDayIn {
  organization_id: string;
  day_date: string;
  day_type: DayType;
  holiday_name?: string | null;
  comment?: string | null;
}

const BASE = '/refs/production-calendar';

export const orgCalendar = {
  year: (organization_id: string, year: number) =>
    api.get<OrgCalendarYear>(`${BASE}/org`, { params: { organization_id, year } })
      .then((r) => r.data),
  setDay: (p: OrgCalendarDayIn) =>
    api.put<CalendarDay>(`${BASE}/org/days`, p).then((r) => r.data),
  /** Повернути типовий день (прибрати власний). */
  resetDay: (organization_id: string, day_date: string) =>
    api.delete(`${BASE}/org/days`, { params: { organization_id, day_date } })
      .then(() => undefined),
  /** Прибрати всі власні дні року. */
  resetYear: (organization_id: string, year: number) =>
    api.delete(`${BASE}/org/days`, { params: { organization_id, year } })
      .then(() => undefined),
  setRegime: (organization_id: string, is_wartime: boolean) =>
    api.put<{ organization_id: string; is_wartime: boolean }>(
      `${BASE}/org/settings`, { organization_id, is_wartime },
    ).then((r) => r.data),
};

export const DAY_TYPE_LABELS: Record<DayType, string> = {
  WORKDAY: 'Робочий',
  WEEKEND: 'Вихідний',
  HOLIDAY: 'Святковий',
  NON_WORKING_DAY: 'Неробочий',
};
